module.exports = __webpack_public_path__ + "static/media/logoFlat.18866a94.svg";